import { Column, Table, VisibilityState, flexRender,
    getCoreRowModel,
    useReactTable,} from '@tanstack/react-table';
import beaconMasterResultType from "../model/BeaconMasterResultType";
import { HTMLProps, useEffect, useState } from 'react';
import { Checkbox } from 'semantic-ui-react';
import React from 'react';
import { Breadcrumb, Button, Col, Form, Row} from 'react-bootstrap';
import axios from 'axios';
import ExcelJS from 'exceljs'; 
import Loading from './Loading';
import beaconResultType from '../model/beaconResultType';
import BeaconModel from '../model/BeaconModel';
import SankeyDiagram from './SankyDiagram';
import SankeyModal from './SankeyModal'; // Ensure this path is correct

type PropsType = {
  result: beaconMasterResultType[],
  bundle_ids: string[],
  apikey: string
}


type uniqueUserType = {
  name: string,
  beacon_id: string,
  log_count: number,
  unique_count: number
}

type uniqueDeviceType = {
  device: number,
  unique_device: number,
  bleOn_device: number,
  bleOn_unique_device: number,
  bleOff_device: number,
  bleOff_unique_device: number,
  locOn_device: number,
  locOn_unique_device: number,
  locOff_device: number,
  locOff_unique_device: number

}


const BeaconMasterResultPastAndFuture = (props:PropsType) => {
  const [detected_gt, setDetcted_gt] = useState<string>("");
  const [detected_lt, setDetcted_lt] = useState<string>("");
  const [bundle_id_ios, setBundle_id_ios] = useState<string>("");
  const [bundle_id_and, setBundle_id_and] = useState<string>("");
  const [bundle_id_gate, setBundle_id_gate] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSankyLoading, setIsSankyLoading] = useState<boolean>(false);
  const beaconResults: BeaconModel[] = [];
  const [numberoflogs, setNumberOfLogs] = useState<string>("10");

  const [beforeSankeyData, setBeforeSankeyData] = useState<{ nodes: { name: string }[], links: { source: string, target: string, value: number }[] }>({ nodes: [], links: [] });
  const [afterSankeyData, setAfterSankeyData] = useState<{ nodes: { name: string }[], links: { source: string, target: string, value: number }[] }>({ nodes: [], links: [] });
  const [sankeyData, setSankeyData] = useState<{ nodes: string[]; links: { source: string; target: string; value: number }[] }>({ nodes: [], links: [] });


  const data: beaconMasterResultType[] = props.result;
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  var opensearchApiurl:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getSpecifiedTimeUniqueDevice/"
  var apiUrl:string = "https://api.bc-loco.jp/api/beacon_logs";
  var beaconApiUrl = "https://api.bc-loco.jp/api/beacons"
  var beaconIdArray : string[] = []
  var bundleIdArray : string[] = []
  var uniqueCountArray : uniqueUserType[] = []
  var uniqueDevice : uniqueDeviceType = {
    device: 0,
    unique_device: 0,
    bleOn_device: 0,
    bleOn_unique_device: 0,
    bleOff_device: 0,
    bleOff_unique_device: 0,
    locOn_device: 0,
    locOn_unique_device: 0,
    locOff_device: 0,
    locOff_unique_device: 0
  }

  //const logHistory : logshistoryType[] = []
  const records: Record<string, any>[] = [];
  const columns = [
    {
      id: 'select',
      header: ({ table }) => (
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      ),
      cell: ({ row }) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    },
    { header: "no", accessorKey: "no" },
    { header: "id", accessorKey: "id" },
    { header: "name", accessorKey: "name" },
    { header: "local_name", accessorKey: "local_name" },
    { header: "uuid", accessorKey: "uuid" },
    { header: "major", accessorKey: "major" },
    { header: "minor", accessorKey: "minor" },
    { header: "action", accessorKey: "action" },
    { header: "tx_power", accessorKey: "tx_power" },
    { header: "battery", accessorKey: "battery" },
    { header: "module_id", accessorKey: "module_id" },
    { header: "manufacturer", accessorKey: "manufacturer" },
    { header: "model", accessorKey: "model" },
    { header: "note", accessorKey: "note" },
    { header: "x", accessorKey: "x" },
    { header: "y", accessorKey: "y" },
    { header: "h", accessorKey: "h" },
    { header: "enabled", accessorKey: "enabled" },
    { header: "created", accessorKey: "created" },
    { header: "updated", accessorKey: "updated" }
    
  ];
    
  const table = useReactTable({columns, data, state: {
      columnVisibility: columnVisibility,
    },
    getCoreRowModel: getCoreRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
  })


  
const getSpecifiedTimeUniqueDevice = async (e: any) => {

    //APIのパラメータ作成
    beaconIdArray.splice(0)
    table.getSelectedRowModel().rows.forEach ((el) => {
        beaconIdArray.push(el.original.id);
    });

    if (isNaN(Number(numberoflogs))) {
      alert("件数は数値で入力して下さい")
      setIsLoading(false);
      return
        
    } else {
      if (parseInt(numberoflogs) <= 0 || parseInt(numberoflogs) >= 1000) {
        alert("件数は1件以上から1000件以内に設定して下さい")
        setIsLoading(false);
        return
      }
    }
    
    if (beaconIdArray.length <= 0) {
        alert("ビーコンが選択されていません。");
        return
    }

    var gte = new Date(detected_gt).getTime() / 1000.0;
    var lte = new Date(detected_lt).getTime() / 1000.0;
    console.log(gte);
    console.log(lte);

    if (isNaN(gte)) {
      alert("Detect_gtが入力されていません");
      return
    } else if (isNaN(lte)) {
      alert("Detect_ltが入力されていません");
      return
    }

    if (bundle_id_ios == "" && bundle_id_and == "" && bundle_id_gate == "") {
      alert("BundleIDが入力されていません");
      return
    } else {
      if (bundle_id_ios != "") {
        bundleIdArray.push(bundle_id_ios)
      }
      if (bundle_id_and != "") {
        bundleIdArray.push(bundle_id_and)
      }
      if (bundle_id_gate != "") {
        bundleIdArray.push(bundle_id_gate)
      }
    }

    //Opensearchから指定時間のユニークなDeviceIDを取得
    
    let ret = true;
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
        
    setIsLoading(true);
    await axios.get(opensearchApiurl,
    {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        params: {
            app_id: bundleIdArray,
            beacons: beaconIdArray,
            gte: gte,
            lte :lte
        }
    })
    .then(async res => {
        console.log(res);
        if(res.status === 400) {
            alert("エラーが発生しました。")
            setIsLoading(false)
            return ret = false
        } 
        const items = JSON.parse(JSON.stringify(res.data.aggregations))
        console.log(items.by_devices.buckets)
        getPastAndFutureDataByDevices(e, items.by_devices.buckets)

    })
    .catch(err => {
          alert("エラーが発生しました。" + err.message)
          ret = false
          setIsLoading(false)
        })
        return ret
}

const getPastAndFutureDataByDevices = async (e: any, devices: string[]) => { 
    try {
        await getBeacons()
    } catch {
        alert("エラーが発生しました。")
        setIsLoading(false);
        return
    }
    //取得したDeviceの指定時間の前後10件分のビーコンログを取得する

    for (const devid of devices) {
        try {
            await getBeforeBeaconLogForDeviceID(devid['key'], "desc", get1MinuteBeforeTime(detected_gt))
            console.log("DeviceID:" + devid['key'])
        } catch  {
            alert("エラーが発生しました。")
            setIsLoading(false);
            return
        }
    }

    for (const devid of devices) {
        try {
            await getAfterBeaconLogForDeviceID(devid['key'], "asc", get1MinuteAfterTime(detected_lt))
            console.log("DeviceID:" + devid['key'])
        } catch  {
            alert("エラーが発生しました。")
            setIsLoading(false);
            return
        }
    }

    for (const devid of devices) {

      records.find((el: any, index: number) => {
        //console.log("beaconid:" + devid['key'])
        if (el.deviceid === devid['key']) {
            records[index]['devid_beacon'] = beaconIdToBeaconName(devid['by_beacon'].buckets[0].key);
        }
            
      })

      /*
      try {
          await getBeaconLogForDeviceID(devid['key'], "desc", detected_gt, detected_lt)
    
          console.log("DeviceID:" + devid['key'])
      } catch  {
          alert("エラーが発生しました。")
          setIsLoading(false);
          return
      }
          */
    }



    //console.log("logHistory:" + logHistory)
    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("PastAndFutureDevice");
    const worksheet = workbook.getWorksheet("PastAndFutureDevice");
    const columns: Partial<ExcelJS.Column>[] = [];
    for (var idx = 1; idx <= parseInt(numberoflogs) ; idx ++) {
        if (idx == 1) {
            columns.push({ header: "DeviceID", key: "deviceid" })
            columns.push({ header: "beforeBeacon" + idx, key: "beforeBeaconid" + idx })
            columns.push({ header: "beforeDetected" + idx, key: "beforeDetected" + idx })
        } else {
            columns.push({ header: "beforeBeacon" + idx, key: "beforeBeaconid" + idx })
            columns.push({ header: "beforeDetected" + idx, key: "beforeDetected" + idx })
        }
    }

    for (var idx = 1; idx <= parseInt(numberoflogs) ; idx ++) {
        columns.push({ header: "afterBeacon" + idx, key: "afterBeaconid" + idx })
        columns.push({ header: "afterDetected" + idx, key: "afterDetected" + idx })
    }
   
    worksheet!.columns = columns;
    records.forEach((el => {
        worksheet!.addRow(el)
    }))
    
    try {
        const uint8Array = await workbook.csv.writeBuffer();
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        setTimeout(()=> {
            a.href = url;
            a.download = "PastAndFutureDevice_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
        },1000)
    
    } catch (error) {
        console.error(error);
    }
    
    setIsLoading(false);
    

    const data = convertRecordsToSankeyData(records);
    setSankeyData(data);
/*
    const beforedata = convertBeforeRecordsToSankeyData(records);
    setBeforeSankeyData(beforedata);
    const afterdata = convertAfterRecordsToSankeyData(records);
    setAfterSankeyData(afterdata);
*/
    setIsSankyLoading(true);
    
}

//中間のーどにする
const getBeaconLogForDeviceID = async (serachDeviceid: string, searchSort:string, searchGte: string, searchLte: string) => {
  try {
      const res = await axios.get(apiUrl, {
          headers: {
              "Authorization": props.apikey,
              "Content-Type": "application/json"
          },
          params: {
              ...({device_id: [serachDeviceid]}),
              ...({per_page: 1}),
              ...(searchGte ? {detected_gt: searchGte.replace("T", " ")} : {}),
              ...(searchLte ? {detected_lt: searchLte.replace("T", " ")} : {}),
              ...({sort: searchSort})
          }
      });

      console.log(res);

      if (res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
          throw new Error("条件設定に問題があります。");
      } else if (res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
          throw new Error("APIKeyが正しく入力されていません。");
      }

      const items = JSON.parse(JSON.stringify(res.data.payload));
      if (items.total > 100000) {
          alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。");
          throw new Error("10万件を超えるデータは表示出来ません。");
      }

      records.find((el: any, index: number) => {
          if (el.deviceid === serachDeviceid) {
              records[index]['devid_beacon'] = beaconIdToBeaconName(items.data[0].beacon_id);
          }
      })

      return Promise.resolve();

  } catch (err: any) {
    alert("エラーが発生しました。" + (err as any).message);
    return Promise.reject(err);
  }
}

const getBeforeBeaconLogForDeviceID = async (serachDeviceid: string, searchSort:string, searchLte: string) => {
    try {
        const res = await axios.get(apiUrl, {
            headers: {
                "Authorization": props.apikey,
                "Content-Type": "application/json"
            },
            params: {
                ...({device_id: [serachDeviceid]}),
                ...({per_page: parseInt(numberoflogs)}),
                ...(searchLte ? {detected_lt: searchLte.replace("T", " ")} : {}),
                ...({sort: searchSort})
            }
        });

        console.log(res);

        if (res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
            throw new Error("条件設定に問題があります。");
        } else if (res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
            throw new Error("APIKeyが正しく入力されていません。");
        }

        const items = JSON.parse(JSON.stringify(res.data.payload));
        if (items.total > 100000) {
            alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。");
            throw new Error("10万件を超えるデータは表示出来ません。");
        }

        var logHistorytemp = {};

        if (items.data.length >= 1) {
            items.data.forEach((value: beaconResultType, index: number) => {
                switch (index) {
                    case 0:
                        logHistorytemp['deviceid'] = serachDeviceid;
                        logHistorytemp['beforeBeaconid' + (index + 1)] = beaconIdToBeaconName(value.beacon_id);
                        logHistorytemp['beforeDetected' + (index + 1)] = value.detected;
                        break;
                    default:
                        logHistorytemp['beforeBeaconid' + (index + 1)] = beaconIdToBeaconName(value.beacon_id);
                        logHistorytemp['beforeDetected' + (index + 1)] = value.detected;
                        break;
                }
                items.from++;
            });

            records.push(logHistorytemp);
        } else {
            logHistorytemp['deviceid'] = serachDeviceid;
            records.push(logHistorytemp);
        }

        return Promise.resolve();
    } catch (err: any) {
        alert("エラーが発生しました。" + (err as any).message);
        return Promise.reject(err);
    }
}

const getAfterBeaconLogForDeviceID = async (serachDeviceid: string, searchSort:string, searchGte: string) => {
    try {
        const res = await axios.get(apiUrl, {
            headers: {
                "Authorization": props.apikey,
                "Content-Type": "application/json"
            },
            params: {
                ...({device_id: [serachDeviceid]}),
                ...({per_page: parseInt(numberoflogs)}),
                ...(searchGte ? {detected_gt: searchGte.replace("T", " ")} : {}),
                ...({sort: searchSort})
            }
        });

        console.log(res);

        if (res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
            throw new Error("条件設定に問題があります。");
        } else if (res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
            throw new Error("APIKeyが正しく入力されていません。");
        }

        const items = JSON.parse(JSON.stringify(res.data.payload));
        if (items.total > 100000) {
            alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。");
            throw new Error("10万件を超えるデータは表示出来ません。");
        }

        items.data.forEach((value: beaconResultType, index: number) => {
            records.forEach((el: any, index2: number) => {
                if (el.deviceid === serachDeviceid) {
                    records[index2]['afterBeaconid' + (index + 1)] = beaconIdToBeaconName(value.beacon_id);
                    records[index2]['afterDetected' + (index + 1)] = value.detected;
                }
            });
            items.from++;
        });

        return Promise.resolve();
    } catch (err) {
        alert("エラーが発生しました。" + (err as any).message);
        return Promise.reject(err);
    }
}

const beaconIdToBeaconName = (beaconid: string) => {
    
    var ret = beaconid

    beaconResults.forEach((beaconValue: BeaconModel) => {
        if (beaconid == beaconValue.id) {
            ret = beaconValue.name;
            return
        }
    })
    return ret
}

const getBeacons = async() => {
    try {
        const res = await axios.get(beaconApiUrl, {
            headers: {
                "Authorization": props.apikey,
                "Content-Type": "application/json"
            },
            params: {
                per_page: 1000
            }
        });
        console.log(res);
        if (res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
            return;
        } else if (res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
            return;
        }
        const items = res.data.payload;
        console.log(items);

        items.data.forEach((value: BeaconModel) => {
            beaconResults.push(value);
        });

        return Promise.resolve();
    } catch (err) {
        alert("エラーが発生しました。" + (err as any).message);
        return Promise.reject(err);
    }
};

  useEffect(() => {
   setBundle_id_ios(props.bundle_ids[0])
   setBundle_id_and(props.bundle_ids[1])
   setBundle_id_gate(props.bundle_ids[2])
  },[])
  

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_gt(value);
  }

  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_lt(value);
  }

  const changeNumberOfLogs = (value: string) => {
    setNumberOfLogs(value);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    let result = y  + m +  d;
    return result;
  }

  const get1MinuteBeforeTime = (time: string) => {
    let dt = new Date(time)
    let before1min_unix = dt.getTime() - 6000
    let before1min = new Date(before1min_unix)
    let y = before1min.getFullYear();
    let m = ("00" + (before1min.getMonth()+1)).slice(-2);
    let d = ("00" + (before1min.getDate())).slice(-2);
    let hour = ("00" + (before1min.getHours())).slice(-2);
    let min = ("00" + (before1min.getMinutes())).slice(-2);
    let sec = ("00" + (before1min.getSeconds())).slice(-2);

    let result = y + "-" + m + "-" + d + " " + hour + ":" + min + ":" + sec

    console.log(result)
    return result
  }

  const get1MinuteAfterTime = (time: string) => {
    let dt = new Date(time)
    let before1min_unix = dt.getTime() + 6000
    let before1min = new Date(before1min_unix)
    let y = before1min.getFullYear();
    let m = ("00" + (before1min.getMonth()+1)).slice(-2);
    let d = ("00" + (before1min.getDate())).slice(-2);
    let hour = ("00" + (before1min.getHours())).slice(-2);
    let min = ("00" + (before1min.getMinutes())).slice(-2);
    let sec = ("00" + (before1min.getSeconds())).slice(-2);

    let result = y + "-" + m + "-" + d + " " + hour + ":" + min + ":" + sec

    console.log(result)
    return result
  }

  const convertRecordsToSankeyData = (records: Record<string, any>[]) => {
    const nodes: string[] = [];
    const links: { source: string; target: string; value: number }[] = [];

    records.forEach((record, index) => {
        const devidBeacon = `${record.devid_beacon}¥C${index}`; // 中間ノードに一意の識別子を付加
        //const devidBeacon = `${record.devid_beacon}`; // 中間ノードに一意の識別子を付加
        if (!nodes.includes(devidBeacon)) {
            nodes.push(devidBeacon);
        }

        // beforeBeaconid1をスタートノードとしてリンクを作成
        if (record.beforeBeaconid1) {
            const beforeBeacon = `${record.beforeBeaconid1}¥B${index}`; // 一意の識別子を付加
            //const beforeBeacon = `${record.beforeBeaconid1}`; // 一意の識別子を付加
            if (!nodes.includes(beforeBeacon)) {
                nodes.push(beforeBeacon);
            }
            links.push({ source: beforeBeacon, target: devidBeacon, value: 1 });
        }

        // afterBeaconid1をエンドノードとしてリンクを作成
        if (record.afterBeaconid1) {
            const afterBeacon = `${record.afterBeaconid1}¥A${index}`; // 一意の識別子を付加
            //const afterBeacon = `${record.afterBeaconid1}`; // 一意の識別子を付加
            if (!nodes.includes(afterBeacon)) {
                nodes.push(afterBeacon);
            }
            links.push({ source: devidBeacon, target: afterBeacon, value: 1 });
        }
    });

    return { nodes, links };
};

  const convertRecordsToSankeyData_s = (records: Record<string, any>[]) => {
    const nodes: string[] = [];
    const links: { source: string; target: string; value: number }[] = [];

    records.forEach((record, index) => {
        // beforeBeaconid1をスタートノードとしてリンクを作成
        if (record.beforeBeaconid1) {
            const beforeBeacon = `${record.beforeBeaconid1}_B${index}`; // 一意の識別子を付加
            /*if (!nodes.includes(beforeBeacon)) {
                nodes.push(beforeBeacon);
            }
            */
            nodes.push(beforeBeacon);

            const devidBeacon = `${record.devid_beacon}_C${index}`; // 一意の識別子を付加
            /*
            if (devidBeacon && !nodes.includes(devidBeacon)) {
                nodes.push(devidBeacon);
            }
            */
            nodes.push(devidBeacon);

            links.push({ source: beforeBeacon, target: devidBeacon, value: 1 });
        }

        // afterBeaconid1をエンドノードとしてリンクを作成
        
        if (record.afterBeaconid1) {
            const afterBeacon = `${record.afterBeaconid1}_A${index}`; // 一意の識別子を付加
            if (!nodes.includes(afterBeacon)) {
                nodes.push(afterBeacon);
            }

            const devidBeacon = `${record.devid_beacon}_C${index}`; // 一意の識別子を付加
            if (devidBeacon && !nodes.includes(devidBeacon)) {
                nodes.push(devidBeacon);
            }

            links.push({ source: devidBeacon, target: afterBeacon, value: 1 });
        }

    });

    return { nodes, links };
  };

  const convertBeforeRecordsToSankeyData = (records: Record<string, any>[]) => {
    const nodes: { name: string }[] = [];
    const links: { source: string, target: string, value: number }[] = [];

    records.forEach(record => {
        const deviceId = record.deviceid;
        if (!nodes.find(node => node.name === deviceId)) {
            nodes.push({ name: deviceId });
        }

        Object.keys(record).forEach(key => {
            if (key.startsWith('beforeBeacon')) {
            //if (key.startsWith('beforeBeacon') || key.startsWith('afterBeacon')) {
                const beaconId = record[key];
                if (beaconId && !nodes.find(node => node.name === beaconId)) {
                    nodes.push({ name: beaconId });
                }
                links.push({ source: deviceId, target: beaconId, value: 1 });
            }
        });
    });

    // リンクがないノードをフィルタリング
    const linkedNodes = new Set(links.flatMap(link => [link.source, link.target]));
    const filteredNodes = nodes.filter(node => linkedNodes.has(node.name));


    return { nodes: filteredNodes, links };
};

const convertAfterRecordsToSankeyData = (records: Record<string, any>[]) => {
  const nodes: { name: string }[] = [];
  const links: { source: string, target: string, value: number }[] = [];

  records.forEach(record => {
      const deviceId = record.deviceid;
      if (!nodes.find(node => node.name === deviceId)) {
          nodes.push({ name: deviceId });
      }

      Object.keys(record).forEach(key => {
          if (key.startsWith('afterBeacon')) {
          //if (key.startsWith('beforeBeacon') || key.startsWith('afterBeacon')) {
              const beaconId = record[key];
              if (beaconId && !nodes.find(node => node.name === beaconId)) {
                  nodes.push({ name: beaconId });
              }
              links.push({ source: deviceId, target: beaconId, value: 1 });
          }
      });
  });

  // リンクがないノードをフィルタリング
  const linkedNodes = new Set(links.flatMap(link => [link.source, link.target]));
  const filteredNodes = nodes.filter(node => linkedNodes.has(node.name));

  return { nodes: filteredNodes, links };
};

  function IndeterminateCheckbox({
      indeterminate,
      className = '',
      ...rest
    }: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
      const ref = React.useRef<HTMLInputElement>(null!)
    
      React.useEffect(() => {
        if (typeof indeterminate === 'boolean') {
          ref.current.indeterminate = !rest.checked && indeterminate
        }
      }, [ref, indeterminate])
    
      return (
        <input
          type="checkbox"
          ref={ref}
          className={className + ' cursor-pointer'}
          {...rest}
        />
      )
    }

    return (
        
      <div>
        
        <Form className="font-weight-bold">
        
          <Form.Group as={Row} className="mx-3">
            <Col xs={12} md={4}>
              <Form.Label>BundleID(iOS)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_ios as string} className="w-27" onChange={(e) => setBundle_id_ios(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>BundleID(Android)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_and as string} className="w-27" onChange={(e) => setBundle_id_and(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>BundleID(GateWay)</Form.Label>
              <Form.Control type="text" name="uuid" disabled value={bundle_id_gate as string} className="w-27" onChange={(e) => setBundle_id_gate(e.target.value)} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mx-3">

            <Col xs={12} md={4}>
              <Form.Label>Detected_gt（ビーコン発見時刻以降）</Form.Label>
              <Form.Control type="datetime-local" step="1" autoComplete="on" name="detected_gt" value={detected_gt as string} className="w-27" placeholder="ビーコン発見時の時刻（>=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedGt(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>Detected_lt（ビーコン発見時刻以前）</Form.Label>
              <Form.Control type="datetime-local" step="1" name="detected_lt" value={detected_lt as string} className="w-27" placeholder="ビーコン発見時の時刻（<=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedLt(e.target.value)} />
            </Col>
            <Col xs={12} md={4}>
              <Form.Label>前後ビーコンログ件数（過去と未来のビーコンログ件数）</Form.Label>
              <Form.Control type="text" name="numberoflogs" value={numberoflogs as string} className="w-27" placeholder="出力する前後のビーコンログ件数を入力" onChange={(e) => changeNumberOfLogs(e.target.value)} />
            </Col>
          </Form.Group>
        
        <div className="text-center">
          <Form.Group as={Button} type="button" className="mt-3 mb-2 mr-2" onClick={(e) =>  getSpecifiedTimeUniqueDevice(e)}>時間内のデバイスの過去と未来を取得</Form.Group>
        </div>
        </Form>

        {(() => {
        if (isSankyLoading) {
          return (
            <div className="text-center">
              <div>
              <SankeyModal data={sankeyData} />
              </div>
            </div>
          )
        }
        })()}
    
        <p className='mx-3'>項目の表示・非表示</p>
        <div id='colVisible' className="px-1 mx-3">
            {table.getAllLeafColumns().map(column => {
            return (
            <label className='mx-3'>

                <input
                    checked={column.getIsVisible()}
                    onChange={column.getToggleVisibilityHandler()}
                    type="checkbox"
                />{' '}
                {column.id}
            </label>
            )
            })}
        </div>
        <div className='dataScroll'>
            <table>
                <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>
                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                        </th>
                    ))}
                    </tr>
                ))}
                </thead>
                <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
        {(() => {
        if (isLoading) {
          return (
            <div>
              <Loading/>
            </div>
          )
        }
        })()}

       
        

      </div>

      
    )
}

export default BeaconMasterResultPastAndFuture